import { NavLink, useLocation } from 'react-router';
import { PageHead } from 'ui/kit/PageHead';

import styles from './TutorAccessClosed.module.scss';

const COPY: Record<string, { crumb: string; heading: string; title: string; fact: string }> = {
  search: {
    crumb: 'Личный кабинет / Поиск',
    heading: 'Поиск заявок',
    title: 'Поиск пока закрыт',
    fact: 'Доступ появится после одобрения профиля.',
  },
  chat: {
    crumb: 'Личный кабинет / Чаты и отклики',
    heading: 'Чаты и отклики',
    title: 'Чаты пока закрыты',
    fact: 'Доступ появится после одобрения профиля.',
  },
  other: {
    crumb: 'Личный кабинет',
    heading: 'Раздел закрыт',
    title: 'Раздел пока закрыт',
    fact: 'Доступ появится после одобрения профиля.',
  },
};

export function TutorAccessClosed() {
  const location = useLocation();
  const key = location.pathname.startsWith('/teacher/search')
    ? 'search'
    : location.pathname.startsWith('/teacher/chat')
      ? 'chat'
      : 'other';
  const copy = COPY[key];

  return (
    <div className={styles.wrap}>
      <PageHead crumb={<>{copy.crumb}</>} title={<>{copy.heading}</>} />
      <div className={styles.card}>
        <div className={styles.empty}>
          <h2 className={styles.emptyTitle}>{copy.title}</h2>
          <p className={styles.emptyFact}>{copy.fact}</p>
          <NavLink to='/teacher/edit' className={styles.action}>
            Продолжить заполнение профиля
          </NavLink>
        </div>
      </div>
    </div>
  );
}
